import { render, staticRenderFns } from "./scope117.vue?vue&type=template&id=5dcb213c&scoped=true"
import script from "./scope117.vue?vue&type=script&lang=js"
export * from "./scope117.vue?vue&type=script&lang=js"
import style0 from "./scope117.vue?vue&type=style&index=0&id=5dcb213c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcb213c",
  null
  
)

export default component.exports